import { render, staticRenderFns } from "./PhotoSideBarTabDeviceItem.vue?vue&type=template&id=58f1552c&scoped=true"
import script from "./PhotoSideBarTabDeviceItem.vue?vue&type=script&lang=js"
export * from "./PhotoSideBarTabDeviceItem.vue?vue&type=script&lang=js"
import style0 from "./PhotoSideBarTabDeviceItem.vue?vue&type=style&index=0&id=58f1552c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f1552c",
  null
  
)

export default component.exports